import {observer} from "mobx-react";
import React, {useContext} from "react";
import {Outlet} from "react-router";
import {AppContext} from "../stores/AppStore";
import useInstance from "../hooks/useInstance";
import {LessonsStore, LessonsStoreContext} from "../stores/LessonsStore";
import {MyRecordingsStoreContext, OrganizationRecordingsStoreContext, RecordingsStore} from "../stores/RecordingsStore";
import {recordings} from "../proto/compiled";

export const HomeLayout = observer(() => {
  const app = useContext(AppContext)!;
  const lessonsStore = useInstance(() => new LessonsStore(app));
  const myRecordingsStore = useInstance(() => new RecordingsStore(app, recordings.RecordingListScope.rls_my));
  const organizationRecordingsStore = useInstance(() => new RecordingsStore(app, recordings.RecordingListScope.rls_organization));
  if (!lessonsStore || !myRecordingsStore || !organizationRecordingsStore) return null;
  return <LessonsStoreContext.Provider value={lessonsStore}>
    <MyRecordingsStoreContext.Provider value={myRecordingsStore}>
      <OrganizationRecordingsStoreContext value={organizationRecordingsStore}>
        <Outlet/>
      </OrganizationRecordingsStoreContext>
    </MyRecordingsStoreContext.Provider>
  </LessonsStoreContext.Provider>;
});